import { formattingTimeWithoutSeconde, formattingDate } from 'utils';

/**
 * Display current date time payment line
 * @param {DateTime} date
 * @param {string} countryCode
 * @returns date with hour (dd/mm/yyyy - HH:mm) or only hour (HH:mm)
 */
export const paymentDateTime = (date, countryCode) => {
  const countryCodeDefault = countryCode ? countryCode : 'FR-fr';
  let dateToCheck = new Date(date);
  let today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  const timeFormatting = formattingTimeWithoutSeconde(date, countryCodeDefault);
  if (dateToCheck < today) {
    const dateFormatting = formattingDate(date, countryCodeDefault);
    return `${dateFormatting} - ${timeFormatting}`;
  } else {
    return timeFormatting;
  }
};
